import { useEffect } from "react";
import { useScheduleContext } from "./context/useScheduleContext";
import { useFilters } from "../../../../utils/hooks/useFilters";

export const useCtrlShiftSHandler = () => {
    const [filters] = useFilters();
    const { type, dispatch, clearSelectedEvents } = useScheduleContext();

    useEffect(() => {
        if (filters?.mode !== "day" && type !== "my-profile") {
            const handleKeyDown = (e: KeyboardEvent) => {
                if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "S") {
                    e.preventDefault();
                    dispatch({ type: "ctrl-shift-s" });
                }
            };
            window.addEventListener("keydown", handleKeyDown);
            return () => {
                window.removeEventListener("keydown", handleKeyDown);
            };
        } else {
            dispatch({ type: "ctrl-shift-s", payload: false });
        }
    }, [filters?.mode, type, dispatch]);

    useEffect(() => {
        clearSelectedEvents();
        dispatch({ type: "ctrl-shift-s", payload: false });
    }, [filters.mode, filters.from, filters.to, clearSelectedEvents, dispatch]);

    return undefined;
}